import {useForm} from "react-hook-form";
import React, {useEffect} from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import SingleValueAutoComplete from "../../BaseComponents/singleValueAutoComplete";
import {getHotels, onDeleteHotel, onPutHotel} from "../../../Services/DatabaseCommunicator/hotel";
import TextField from "../../BaseComponents/textField";

interface Inputs {

    options: string[];

    id: number | undefined;
    hotelName: string;

    address: string;

    neighbourhood: string;
    city: string;
    phoneNumber: string;

}

const HotelModifierForm = () => {
    const {register, setValue, handleSubmit, control, formState: {errors}} = useForm<Inputs>({
        criteriaMode: "all",
        defaultValues: {
            id: undefined,
            hotelName: ""
        }
    });

    const [optionNames, setOptionNames] = React.useState<string[]>([""]);
    const [options, setOptions] = React.useState<{ [key: string | number]: any }[]>([]);
    const [message, setMessage] = React.useState<string>("");

    const fetchHotels = async () => {
        const hotels = await getHotels();
        setOptions(hotels);
        const optionNames = hotels.map(hotel => hotel?.name).filter(name => name !== undefined) as string[];
        setOptionNames(optionNames);
    }

    useEffect(() => {
        fetchHotels();
    }, [])

    const onSearchOptionSelected = (optionName: string) => {
        const option = options.find((obj: { [key: string]: any }) => obj.name === optionName);
        setValue("id", undefined)

        if (!option)
            return;

        setValue("id", option.id)
        setValue("hotelName", option.name);
        setValue("address", option.address);
        setValue("neighbourhood", option.neighbourhood);
        setValue("city", option.city);
        setValue("phoneNumber", option.phone);
    }
    const onSubmit = async (data: Inputs) => {
        const hotelWasPut = await onPutHotel(data.id, data.hotelName, data.address, data.neighbourhood, data.city, data.phoneNumber);
        if (hotelWasPut)
            setMessage("Successfully updated data.");
        else
            setMessage("Could not update data.");
        clearFormValues();
        await fetchHotels();
    }

    const onClear = () => {
        setMessage("");
        clearFormValues();
    }

    const clearFormValues = () => {
        setValue("hotelName", "");
        setValue("id", undefined);
        setValue("address", "");
        setValue("neighbourhood", "");
        setValue("city", "");
        setValue("phoneNumber", "");
    }
    const onDelete = async (data: Inputs) => {
        const isDeleted = await onDeleteHotel(data.hotelName);
        if (!isDeleted) {
            setMessage("Could not delete data.");
            return;
        }

        clearFormValues();
        setMessage("Successfully deleted data.");
        await fetchHotels();
    }

    return (
        <div className={"HotelModifierForm"}>
            <Box
                style={{
                    alignItems: "center",
                }}
                sx={{
                    '& .MuiTextField-root': {m: 1, width: '25ch'},
                }}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Stack direction={"column"} spacing={2} alignItems={"center"} justifyContent={"center"}>
                        <Stack direction={"row"} alignItems={"center"} spacing={2} justifyContent={"flex-start"}>
                            <SingleValueAutoComplete options={optionNames} freeSolo={true} name={"hotelName"}
                                                     label={"Hotel Name"}
                                                     control={control} register={register} errors={errors}
                                                     required={true}
                                                     onOptionSelected={onSearchOptionSelected}/>
                            <Button variant={"outlined"} onClick={onClear}>Clear</Button>

                        </Stack>

                        <TextField control={control} name={"hotelName"} label={"Hotel name"} register={register}
                                   errors={errors}/>
                        <TextField control={control} name={"address"} label={"Address"} register={register}
                                   errors={errors}/>
                        <TextField control={control} name={"city"} label={"City"} register={register} errors={errors}/>
                        <TextField control={control} name={"neighbourhood"} label={"Neighbourhood"} register={register}
                                   errors={errors} isRequired={false}/>
                        <TextField control={control} name={"phoneNumber"} label={"Phone Number"} register={register}
                                   errors={errors}
                                   rules={{
                                       pattern: {
                                           value: /^\+90\s?\d{3}\s?\d{3}\s?\d{2}\s?\d{2}$/,
                                           message: "Invalid number format."
                                       }
                                   }}/>

                        <Stack direction={"row"} alignItems={"baseline"} spacing={2} justifyContent={"flex-start"}>
                            <Button variant={"outlined"} onClick={handleSubmit(onSubmit)}>Save</Button>
                            <Button variant={"outlined"} onClick={handleSubmit(onDelete)}>Delete</Button>
                        </Stack>
                        <Typography>{message}</Typography>
                    </Stack>
                </form>
            </Box>
        </div>
    )
}

export default HotelModifierForm;